import React, { useMemo } from "react";
import "../css/components/Counter.css";

const Counter = ({ value, onChange, min = 0, dynamicWidth = false }) => {
  const handleIncrement = () => {
    onChange(value + 1);
  };

  const handleDecrement = () => {
    if (value > min) {
      onChange(value - 1);
    }
  };

  const handleInputChange = (e) => {
    const newValue = parseInt(e.target.value, 10);
    if (!isNaN(newValue) && newValue >= min) {
      onChange(newValue);
    }
  };

  const inputWidth = useMemo(() => {
    if (!dynamicWidth) return undefined;
    
    // Calculate width based on number of digits
    const digitCount = String(Math.abs(value)).length;
    const baseWidth = 60; // Base width for 1 digit (matches min-width in CSS)
    const digitWidth = 24; // Width equivalent to 2 digits per additional digit
    const padding = 4; // Total padding (2x on each side)
    
    return Math.max(baseWidth, digitCount * digitWidth + padding);
  }, [value, dynamicWidth]);

  const inputStyle = useMemo(() => {
    if (!dynamicWidth) return {};
    return { width: `${inputWidth}px` };
  }, [dynamicWidth, inputWidth]);

  return (
    <div className="counter-container">
      <button
        className="counter-button"
        onClick={handleDecrement}
        disabled={value <= min}
      >
        -
      </button>
      <input
        type="number"
        className="counter-input"
        style={inputStyle}
        value={value}
        onChange={handleInputChange}
        min={min}
      />
      <button className="counter-button" onClick={handleIncrement}>
        +
      </button>
    </div>
  );
};

export default Counter;
